import React from 'react'
import BuyerFields from './Role/BuyerFields'
import SellerFields from './Role/SellerFields'

const UserFieldsView = (props) => {
    return props.seller ? (
        <SellerFields
            data={props.data}
            fieldValue={props.fieldValue}
            function={props.function}
            customInitial={props.customInitial}
            customValidation={props.customValidation}
            additionalFormikUpdate={props.additionalFormikUpdate}
            changePassword={props.changePassword}
            standalone={props.standalone}
            loadOff={props.loadOff}
        />
    ) : (
        <BuyerFields
            data={props.data}
            fieldValue={props.fieldValue}
            function={props.function}
            customInitial={props.customInitial}
            customValidation={props.customValidation}
            additionalFormikUpdate={props.additionalFormikUpdate}
            invoiceTab={props.invoiceTab}
            changePassword={props.changePassword}
            noCredits={props.noCredits}
            creditLabel={props.creditLabel}
            creditTextChange={props.creditTextChange}
            standalone={props.standalone}
            loadOff={props.loadOff}
        />
    )
}

export default UserFieldsView
